<div {...$$restProps} class={$$restProps.class}><slot /></div>
